import {Checkbox as CheckboxBase} from '@yandex-delivery/blocks'
import React from 'react'
import {useController, useFormContext} from 'react-hook-form'

import {scoped} from '../../utils'
import type {Props} from './Checkbox.types'

export function Checkbox({
  name,
  rules,
  shouldUnregister,
  defaultValue,
  ...otherProps
}: Props): React.ReactElement<Props> {
  const {control} = useFormContext()

  const {
    fieldState: {error},
    field: {value, onChange, onBlur},
  } = useController({control, name, rules, shouldUnregister, defaultValue})

  return (
    <CheckboxBase
      {...otherProps}
      checked={value}
      error={error?.message}
      name={name}
      onBlur={onBlur}
      onChange={onChange}
    />
  )
}

export const ScopedCheckbox = scoped(CheckboxBase, {valueKey: 'checked'})
